module.exports = __webpack_public_path__ + "img/MILANO.43b30e5e.png";